'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _renderQuery = require('../renderers/renderQuery');

var _renderQuery2 = _interopRequireDefault(_renderQuery);

var _formatting = require('../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDeclarationWithQuery = function wrapDeclarationWithQuery(query) {
  return (0, _ramda.unless)(function () {
    return (0, _ramdaAdjunct.isNull)(query);
  }, (0, _renderQuery2.default)(query));
};

var writeToString = function writeToString(outputString) {
  return (0, _ramda.compose)(_formatting.joinWithDoubleNewlines, _ramdaAdjunct.compact, (0, _ramdaAdjunct.appendFlipped)([outputString]));
};

var renderStyle = function renderStyle(outputString, _ref) {
  var name = _ref.name,
      query = _ref.query,
      value = _ref.value;
  return (0, _ramda.pipe)(_formatting.joinWithNewline, wrapDeclarationWithQuery(query, name), writeToString(outputString))(value);
};

var renderStyles = (0, _ramda.reduce)(renderStyle, '');

exports.default = renderStyles;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/build/renderStyles.js
// module id = 651
// module chunks = 168707334958949